import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const taskList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/task/list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};

export const taskCount = (params) => {
  return _baseClient.post('/task/list', { body: params });
};

export const taskAssignList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/task-assign/list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};

export const getTaskOutlookList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/task-outlook/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const taskOutlookCount = (params) => {
  return _baseClient.post('/task-outlook/list', { body: params });
};

export const exportTaskOutlookList = (params) => {
  return _baseClient.post('/task-outlook/export', { body: params }).then((response) => {
    return response;
  });
};

export const taskOutlookList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.post('/task-outlook/list', {
    body: {
      pageSize: pageSize,
      pageNumber: pageNumber,
      ...query,
    },
  });
};

export const exportTaskList = (params) => {
  return _baseClient.post('/task/export', { body: params }).then((response) => {
    return response;
  });
};

export const taskSave = (params) => {
  return _baseClient.post('/task/save', { body: params }).then((response) => {
    return response;
  });
};

export const taskDelete = (params) => {
  return _baseClient.post('/task/delete', { body: params });
};
export const taskReviewComplete = (params) => {
  return _baseClient.post('/task/review-complete', { body: params });
};
export const taskRemoveReview = (params) => {
  return _baseClient.post('/task/remove-review', { body: params });
};
export const taskClone = (params) => {
  return _baseClient.get('/task/clone', params);
};
export const taskComplete = (params) => {
  return _baseClient.post('/task/complete', { body: params });
};
export const taskChangeAssignee = (params) => {
  return _baseClient.post('/task/change-assignee', { body: params });
};
export const taskChangePriority = (params) => {
  return _baseClient.post('/task/change-priority', { body: params });
};

export const taskChangeStatus = (params) => {
  return _baseClient.post('/task/change-status', { body: params });
};

export const taskComplianceStatus = (params) => {
  return _baseClient.post('/task/change-compliance-status', { body: params });
};

export const taskRiskRank = (params) => {
  return _baseClient.post('/task/change-risk-rank', { body: params });
};

export const taskInitialBoardDate = (params) => {
  return _baseClient.post('/task/change-initial-board-date', { body: params });
};

export const taskSearch = (params) => {
  return _baseClient.get('/task/search', params);
};

export const taskGet = (params) => {
  return _baseClient.get('/task/get', params);
};

export const getUnitProject = (params) => {
  return _baseClient.post('/project/get-unit-projects', { body: params });
};

export const taskAssignSave = (params) => {
  return _baseClient.post('/task-assign/save', { body: params }).then((response) => {
    return response;
  });
};

export const taskGridColumnSave = (params) => {
  return _baseClient.post('/task-grid-column/save', { body: params }).then((response) => {
    return response;
  });
};

export const taskGridColumnList = (params) => {
  return _baseClient.get('/task-grid-column/list').then((response) => {
    return response;
  });
};

export const taskScheduleGridColumnList = (params) => {
  return _baseClient.get('/schedule-grid-column/list').then((response) => {
    return response;
  });
};

export const outlookGridColumnList = (params) => {
  return _baseClient.get('/outlook-grid-column/list').then((response) => {
    return response;
  });
};

export const outlookGridColumnSave = (params) => {
  return _baseClient.post('/outlook-grid-column/save', { body: params }).then((response) => {
    return response;
  });
};

export const taskScheduleGridColumnSave = (params) => {
  return _baseClient.post('/schedule-grid-column/save', { body: params }).then((response) => {
    return response;
  });
};

export const taskFilterGroupSave = (params) => {
  return _baseClient.post('/filter-group/add', { body: params }).then((response) => {
    return response;
  });
};

export const taskFilterGroupList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/filter-group/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const taskFilterGroupDelete = (query = {}) => {
  return _baseClient.get('/filter-group/delete', {
    ...query,
  });
};

export const taskFilterGroupGet = (query = {}) => {
  return _baseClient.get('/filter-group/get', {
    ...query,
  });
};

export const taskFilterReportList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/filter-report/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const taskFilterReportDelete = (query = {}) => {
  return _baseClient.get('/filter-report/delete', {
    ...query,
  });
};

export const taskFilterReportGet = (query = {}) => {
  return _baseClient.get('/filter-report/get', {
    ...query,
  });
};

export const taskHistoryList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/task-history/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};
export const taskNotesList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/task-note/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const taskNoteDelete = (params) => {
  return _baseClient.get('/task-note/delete', params);
};
export const taskNoteGet = (params) => {
  return _baseClient.get('/task-note/get', params);
};

export const taskNoteSave = (params) => {
  return _baseClient.post('/task-note/save', { body: params });
};

export const taskNotesUnsticky = (params) => {
  return _baseClient.get('/task-note/unsticky', params);
};

export const taskReminderList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/task-reminder/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const taskReminderSave = (params) => {
  return _baseClient.post('/task-reminder/save', { body: params });
};

export const taskReminderDelete = (params) => {
  return _baseClient.get('/task-reminder/delete', params);
};

export const taskMailSend = (params) => {
  return _baseClient.post('/task-mail/send', { body: params });
};

export const taskMailGet = (params) => {
  return _baseClient.get('/task-mail/get', params);
};

export const taskChangeOpenDueDateComplete = (params) => {
  return _baseClient.post('/task/change-open-due-date', { body: params });
};

export const filterReportAdd = (params) => {
  return _baseClient.post('/filter-report/add', { body: params });
};
export const filterReportGet = (params) => {
  return _baseClient.get('/filter-report/get', params);
};
